/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Context_Menu_Paste_AttributesInputs */

const en_context_menu_paste_attributes = /** @type {(inputs: Context_Menu_Paste_AttributesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paste Attributes...`)
};

const fr_context_menu_paste_attributes = /** @type {(inputs: Context_Menu_Paste_AttributesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coller les attributs...`)
};

const de_context_menu_paste_attributes = /** @type {(inputs: Context_Menu_Paste_AttributesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Attribute einfügen...`)
};

const it_context_menu_paste_attributes = /** @type {(inputs: Context_Menu_Paste_AttributesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incolla attributi...`)
};

const ru_context_menu_paste_attributes = /** @type {(inputs: Context_Menu_Paste_AttributesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вставить атрибуты...`)
};

const es_context_menu_paste_attributes = /** @type {(inputs: Context_Menu_Paste_AttributesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pegar atributos...`)
};

const zh_cn2_context_menu_paste_attributes = /** @type {(inputs: Context_Menu_Paste_AttributesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`粘贴属性...`)
};

const ja_context_menu_paste_attributes = /** @type {(inputs: Context_Menu_Paste_AttributesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`属性を貼り付け...`)
};

const hi_context_menu_paste_attributes = /** @type {(inputs: Context_Menu_Paste_AttributesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`विशेषताएँ पेस्ट करें...`)
};

const pt_pt2_context_menu_paste_attributes = /** @type {(inputs: Context_Menu_Paste_AttributesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Colar atributos...`)
};

/**
* | output |
* | --- |
* | "Paste Attributes..." |
*
* @param {Context_Menu_Paste_AttributesInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const context_menu_paste_attributes = /** @type {((inputs?: Context_Menu_Paste_AttributesInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Context_Menu_Paste_AttributesInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_context_menu_paste_attributes(inputs)
	if (locale === "de") return de_context_menu_paste_attributes(inputs)
	if (locale === "it") return it_context_menu_paste_attributes(inputs)
	if (locale === "ru") return ru_context_menu_paste_attributes(inputs)
	if (locale === "es") return es_context_menu_paste_attributes(inputs)
	if (locale === "zh-CN") return zh_cn2_context_menu_paste_attributes(inputs)
	if (locale === "ja") return ja_context_menu_paste_attributes(inputs)
	if (locale === "hi") return hi_context_menu_paste_attributes(inputs)
	if (locale === "pt-PT") return pt_pt2_context_menu_paste_attributes(inputs)
	return en_context_menu_paste_attributes(inputs)
});